import clsx from "clsx";
import React from "react";

import AdInContent from "~/components/ads/AdInContent";

interface Props {
  className?: string | null,
  children: React.ReactNode,
}

const AdditionalInfo: React.FC<Props> & { componentType: string } = (
  {
    className = null,
    children = null
  }
) => {
  return (
    <>
      {/*<AdInContent adId="R-A-7013740-3" />*/}
      <section
        className={clsx(
          "flex flex-col gap-2 w-full pb-8",
          "dark:bg-opacity-20 text-wrap break-words",
          className
        )}
      >
        {children}
      </section>
    </>
  );
};

/**
 * This identifier is needed for AdditionalContentLayout to gateher table of contents.
 * I can not use "name" property since component names are stripped out in minified in production build.
 */
AdditionalInfo.componentType = 'AdditionalInfo';


export default AdditionalInfo;